import styled from 'styled-components';

const StyledBannerTech = styled.div`
  position: relative;
  background-color: #fff;
  padding-top: ${props => props.theme.components_spacing_desk.xxlarge}px;
  padding-bottom: ${props => props.theme.components_spacing_desk.xxlarge}px;
  padding-right: 64px;
  padding-left: 64px;
  .banner-tech--content{
    position: relative
    width: 100%;
    display: flex;
    align-items: flex-start;
    justify-content: space-between;
  }
  .banner-tech--content-col{
    position: relative;
    text-align: right;
  }
  .col--img{
    flex: 0 0 24.99%;
  }
  .col--img img{
    display: block;
    width: 100%;
  }
  .col--text{
    flex: 0 0 74.97%;
  }
  h5{
    padding-bottom: 40px;
  }
  @media screen and (max-width: 1439px){
    padding-right: 40px;
    padding-left: 40px
  }
  @media screen and (max-width: 1023px){
    h5{
      padding-bottom: 32px;
    }
    padding-top: ${props => props.theme.components_spacing_tablet.xxlarge}px;
    padding-bottom: ${props => props.theme.components_spacing_tablet.xxlarge}px;
  }
  @media screen and (max-width: 767px){
    
    h5{
      padding-bottom: 24px;
    }
    padding-right: 24px;
    padding-left: 24px;
    padding-top: ${props => props.theme.components_spacing_mobile.xxlarge}px;
    padding-bottom: ${props => props.theme.components_spacing_mobile.xxlarge}px;
  }
`;

export {
  StyledBannerTech,
};

